// @flow
import styled from 'styled-components';
import { above, below } from '../../assets/css/media';
import colors from '../../assets/css/colors';

export const TeamUserAvatarWrapper = styled.div`
	display: flex;
	align-items: center;
	height: ${({ height }) => height || 'auto'};
	${below.desktop`
		width: 60%;
	`}
	img {
		width: 40px;
		height: 40px;
		margin-right: .5em;
		border-radius: 50%;
		
		${below.desktop`
			width: 30px;
			height: 30px;
			margin-right: 10px;
		`}
	}

	p {
		font-size: 14px;
		line-height: 1.5;
		color: ${colors.nrlDarkGreen};
		${above.tablet`
			margin-right: 1em;
		`}
		${below.desktop`
			font-size: 12px;
		`}
	}
`;

export default TeamUserAvatarWrapper;


// WEBPACK FOOTER //
// ./src/components/Team/TeamUserAvatarWrapper.js